import { render, staticRenderFns } from "./TotalBoardList.vue?vue&type=template&id=44e49688&scoped=true"
import script from "./TotalBoardList.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardList.ts?vue&type=script&lang=ts&external"
import style0 from "./TotalBoardList.vue?vue&type=style&index=0&id=44e49688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e49688",
  null
  
)

export default component.exports